export class ContentClient {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }

    /**
     * Constructs requests header structure
     * @param {String} token - keycloak token
     */
    getRequestHeaders = token => (token ? { authorization: `Bearer ${token}` } : {});

    /**
     * Get all forms for assessment, optionally filtered by language
     * @param {Array<String} language - list of desired languages, e.g. ['eng', 'spa']
     * @param {String} token - keycloak token for API authorization
     * @returns {Promise}
     */
    async getForms(language = [], token = '') {
        const headers = this.getRequestHeaders(token);
        const params = {
            language: language.join(','),
        };

        return this.httpClient.get(this.constructor.FORMS_URL, {
            params,
            headers,
        });
    }

    /**
     * Get all cutscores for assessment, optionally filtered by language
     * @param {Array<String} language - list of desired languages, e.g. ['eng', 'spa']
     * @param {String} token - keycloak token for API authorization
     * @returns {Promise}
     */
    async getCutscores(language = [], token = '') {
        const headers = this.getRequestHeaders(token);
        const params = {
            language: language.join(','),
        };
        return this.httpClient.get(this.constructor.CUTSCORES_URL, {
            params,
            headers,
        });
    }

    /**
     * Get assessment secure form by form Uid
     * @param {String} formUid - form Uid to retrieve
     * @param {Number} year - school year
     * @param {String} token - keycloak token for API authorization
     * @returns {Promise}
     */
    async getSecureForm(formUid, year, token) {
        const headers = this.getRequestHeaders(token);
        const formUrl = `${this.constructor.SECURE_FORMS_URL}/${formUid}?school_year=${year}&assessment_name=${this.constructor.ASSESSMENT_SHORT_NAME}`;
        const params = {};
        return this.httpClient.get(formUrl, {
            params,
            headers,
        });
    }

    /**
     * Get assessment form by form Uid
     * @param {String} formUid - form Uid to retrieve
     * @param {String} token - keycloak token for API authorization
     * @returns {Promise}
     */
    async getForm(formUid, token) {
        const headers = this.getRequestHeaders(token);
        const formUrl = `${this.constructor.FORMS_URL}/${formUid}`;
        const params = {};
        return this.httpClient.get(formUrl, {
            params,
            headers,
        });
    }
}

export default ContentClient;
